export type DataSource =
  | 'FIELD_REPORT'
  | 'REGULATORY'
  | 'SATELLITE';

export const DATA_SOURCES: DataSource[] = [
  'FIELD_REPORT',
  'REGULATORY',
  'SATELLITE',
];

export const DATA_SOURCE_LABEL: Record<DataSource, string> = {
  FIELD_REPORT: 'Field Report',
  REGULATORY: 'Regulatory',
  SATELLITE: 'Satellite',
};

export const DATA_SOURCE_COLOR: Record<DataSource, string> = {
  FIELD_REPORT: 'bg-gray-700',
  REGULATORY: 'bg-gray-700',
  SATELLITE: 'bg-gray-700',
};
